import { displayApiErrorToast } from "core/src/slices/ui/useCases/display-api-error-toast/display-api-error-toast.use-case";
import { createAppAsyncThunk } from "core/src/store/store.types";
import { EtlApiTarget } from "etl/types";

export type TriggerPreProcessRequest = {
	type?: "csv" | "file"
	triggerFilters?: string[]
}

/**
 * [US-5924] Toast verdict is now posted by the PreProcessor component when the
 * worker reports the outcome (running → done/error). Posting a SUCCESS toast
 * here as soon as the trigger returns was a lie: the HTTP call only queues the
 * job, it doesn't run it. Removed to avoid false positives on FileNotFound.
 */
export const triggerPreProcess = createAppAsyncThunk<void, TriggerPreProcessRequest>(
	"formStep/triggerPreProcess",
	async ({ type, triggerFilters }, { getState, extra, dispatch, rejectWithValue }) => {
		try {
			const { selectedEtlImportUuid } = getState().etlData;
			if (!selectedEtlImportUuid) return;

			if (!type || type === "csv") {
				await extra.etlClient.trigger(EtlApiTarget.PRE_PROCESS_CSV_API, selectedEtlImportUuid, { triggerFilters })
			}

			if (!type || type === "file") {
				await extra.etlClient.trigger(EtlApiTarget.PRE_PROCESS_FILES_API, selectedEtlImportUuid, { triggerFilters })
			}

		} catch (error) {
			dispatch(displayApiErrorToast(error.response))
			throw rejectWithValue(error.response.data.message);
		}
	},
	{
		condition: (_, { getState }) => {
			if (getState().formStep.preProcessRunning) return false;
		}
	}
);
